// src/api/LanguageHelper.js
import i18n from '../i18n';

export const getCurrentLanguage = () => {
    const lang = localStorage.getItem('selectedLanguage');
    return lang || 'en_IN';
};

export const setLanguage = (language) => {
    let langCode;
    switch(language) {
        case 'Telugu':
            langCode = 'te_IN';
            break;
        case 'Hindi':
            langCode = 'hi_IN';
            break;
        case 'English':
        default:
            langCode = 'en_IN';
            break;
    }
    
    localStorage.setItem('selectedLanguage', langCode);
    i18n.changeLanguage(langCode);
    console.log('Language changed to:', langCode);
    return langCode;
};

export const getLanguageFromCode = (code) => {
    switch(code) {
        case 'te_IN':
            return 'Telugu';
        case 'hi_IN':
            return 'Hindi';
        case 'en_IN':
        default:
            return 'English';
    }
};